import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import '../../styles/overview.scss'
import { InfoCard2 } from '../../../widgets/components/UI/InfoCard2'
import TextInput from '../../../widgets/components/Input/TextInput'
import { Col, Modal, Row } from 'react-bootstrap'
import { Form, Formik } from 'formik'
import TagifyInput from '../../../shared-access/components/tagify-input'
import { ToolTipUIForModal } from '../../../widgets/components/UI/ToolTipUIForModal'
import { SelectInput } from '../../../widgets/components/Input/SelectInput'
import { useAuth } from '../../../auth'
import {
  createScheduleTemplate,
  editScheduleTemplate,
  getAllUsers,
  getTemplates,
} from '../../core/_requests'
import { toast } from 'react-toastify'
import SelectSearchInput from '../../../widgets/components/Input/SelectSearchInput'
import TagInput from '../../../widgets/components/Input/TagInput'
import * as Yup from 'yup'
import Skeleton from 'react-loading-skeleton'

const ScheduleReportModal = ({
  isActive,
  setIsActive,
  getAllSchedules,
  setTabKey,
  scheduleId,
  setScheduleId,
}: any) => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const [, setLoading] = useState<boolean>(false)
  const [templateOptions, setTemplateOptions] = useState<any>([])
  const [, setTemplateData] = useState<any>([])
  const [templateId, setTemplateId] = useState<string>('')
  const [scheduleReportData, setScheduleReportData] = useState<any>(null)
  const [scheduleData, setScheduleData] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [userList, setUserList] = useState<any[]>([])
  const [emailList, setEmailList] = useState<any[]>([])
  const [emailListLoading, setEmailListLoading] = useState<boolean>(false)
  const [scheduleDataLoading, setScheduleDataLoading] = useState<boolean>(false)
  console.log(scheduleId, 'scheduleid')

  const getSingleSchedule = async (scheduleId: string) => {
    if (!companyId || !scheduleId) return
    setScheduleDataLoading(true)
    const type = 'Schedule'
    const all = false
    try {
      const {
        data: { data, success, errors },
      } = await getTemplates(
        companyId,
        type,
        all,
        undefined,
        undefined,
        undefined,
        undefined,
        scheduleId
      )
      if (success) {
        setScheduleData(data?.data[0])

        setIsActive(true)
      } else {
        toast.error(errors.name)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setScheduleDataLoading(false)
    }
  }

  useEffect(() => {
    if (scheduleId) {
      getSingleSchedule(scheduleId)
    }
  }, [scheduleId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getAllEmailList = async () => {
    setEmailListLoading(true)
    if (!companyId) return
    try {
      const {
        data: { data, success },
      } = await getAllUsers(companyId)
      if (success) {
        console.log(data)

        const formattedData = data?.map((item: any) => ({
          id: item.userId,
          value: item.name,
          name: item.name,
        }))

        setUserList(formattedData)

        const formattedEmail = data?.map((item: any) => ({
          id: item.userId,
          value: item.email,
          label: item.email,
        }))
        setEmailList(formattedEmail)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setEmailListLoading(false)
    }
  }

  useEffect(() => {
    getAllEmailList()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const userSchema = Yup.object().shape({
    reportTemplate: Yup.object()
      .shape({
        id: Yup.string().required('Template ID is required'),
        label: Yup.string().required('Template name is required'),
        value: Yup.string().required('Template value is required'),
      })
      .nullable()
      .required('Template name is required'),
    scheduleName: Yup.string().nullable().required('Activity Type is required'),
    reportFrequency: Yup.string().nullable().required('Report Frequency is required'),
    reportEmail: Yup.array()
      .min(1, 'At least one email should be selected.')
      .required('At least one email should be selected.'),
  })

  const initialValues = {
    reportTemplate:
      scheduleReportData?.recordTemplateId || scheduleData?.recordKeeperTemplate?.recordTemplateId
        ? {
          id:
            scheduleReportData?.recordTemplateId ||
            scheduleData?.recordKeeperTemplate?.recordTemplateId,
          label: scheduleReportData?.name || scheduleData?.recordKeeperTemplate?.name || '',
          value: scheduleReportData?.name || scheduleData?.recordKeeperTemplate?.name || '',
        }
        : { id: '', label: '', value: '' },

    scheduleName: scheduleData?.name || scheduleReportData?.scheduleName || '',
    AccessActivity:
      scheduleReportData?.reportType || scheduleData?.recordKeeperTemplate?.reportType || '',
    recordAccess:
      scheduleReportData?.recordAccess || scheduleData?.recordKeeperTemplate?.recordAccess || '',
    permissionChanges:
      scheduleReportData?.permissionChanges ||
      scheduleData?.recordKeeperTemplate?.permissionChanges ||
      false,
    unauthorized:
      scheduleReportData?.unauthorized || scheduleData?.recordKeeperTemplate?.unauthorized || false,
    linkSharing:
      scheduleReportData?.linkSharing || scheduleData?.recordKeeperTemplate?.linkSharing || false,
    geoLocation:
      scheduleReportData?.geoLocation || scheduleData?.recordKeeperTemplate?.geoLocation || false,
    validUsers:
      scheduleReportData?.listOfUser ||
      userList
        .filter((user) => {
          const userIds = scheduleData?.recordKeeperTemplate?.listOfUser
            ? String(scheduleData?.recordKeeperTemplate?.listOfUser).split(', ')
            : []

          return userIds.includes(String(user.id))
        })
        .map((user) => user.name),
    departmentLists: Array.isArray(
      scheduleReportData?.departments || scheduleData?.recordKeeperTemplate?.departments
    )
      ? (scheduleReportData?.departments || scheduleData?.recordKeeperTemplate?.departments).map(
        (option: any) => ({
          id: option?.levelOneId || '',
          label: option?.name || '',
          value: option?.name || '',
        })
      )
      : [],
    categoryLists: Array.isArray(
      scheduleReportData?.recordClassificationLevelTwos ||
      scheduleData?.recordKeeperTemplate?.recordClassificationLevelTwos
    )
      ? (
        scheduleReportData?.recordClassificationLevelTwos ||
        scheduleData?.recordKeeperTemplate?.recordClassificationLevelTwos
      ).map((option: any) => ({
        id: option?.levelTwoId || '',
        label: option?.name || '',
        value: option?.name || '',
      }))
      : [],
    format: scheduleReportData?.format || scheduleData?.recordKeeperTemplate?.format || '',
    reportFrequency: scheduleData?.frequency || '',
    reportEmail:
      scheduleData?.email.split(',').map((email: string) => ({
        id: email,
        label: email,
        value: email,
      })) || [],
  }

  const handleSubmit = async (values: any, { resetForm }: any) => {
    try {
      if (
        !companyId ||
        !(
          scheduleReportData?.recordTemplateId ||
          scheduleData?.recordKeeperTemplate?.recordTemplateId
        )
      ) {
        return
      }

      setIsLoading(true)
      const payload: any = {
        name: values?.scheduleName,
        frequency: values?.reportFrequency,
        email: values?.reportEmail?.map((email: any) => email.value).join(','),
        templateId:
          scheduleReportData?.recordTemplateId ||
          scheduleData?.recordKeeperTemplate?.recordTemplateId,
      }
      if (scheduleReportData || scheduleData) {
        payload.scheduleId = scheduleData?.scheduleId
      }
      if (scheduleData?.scheduleId) {
        const {
          data: { success, errors },
        } = await editScheduleTemplate(companyId, payload, scheduleData?.scheduleId)
        if (success) {
          toast.success('Schedule report  edited successfully')
          resetForm()
          setIsActive(false)
          setTabKey(2)
          getAllSchedules()
        } else {
          toast.error(errors.name)
        }
      } else {
        const {
          data: { success, errors },
        } = await createScheduleTemplate(companyId, payload)
        if (success) {
          toast.success('Schedule report created successfully')
          resetForm()
          setIsActive(false)
          setScheduleReportData(null)
          getAllSchedules()
        } else {
          toast.error(errors.name)
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  const getAllTemplates = async () => {
    if (!companyId) return
    setLoading(true)
    const type = 'Template'
    const all = true
    try {
      const {
        data: { data, success, errors },
      } = await getTemplates(companyId, type, all)
      if (success) {
        setTemplateData(data?.data)
        setTemplateOptions(
          data?.data?.map((option: any) => ({
            id: option.recordTemplateId,
            label: option.name,
            value: option.name,
          }))
        )
      } else {
        toast.error(errors.name)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getAllTemplates()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getSingleTemplates = async () => {
    if (!companyId || !templateId) return
    setLoading(true)
    const type = 'Template'
    const all = false
    try {
      const {
        data: { data, success, errors },
      } = await getTemplates(
        companyId,
        type,
        all,
        undefined,
        undefined,
        undefined,
        undefined,
        templateId
      )
      if (success) {
        setScheduleReportData(data?.data[0])
      } else {
        toast.error(errors.name)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  console.log(initialValues, 'initialvalues')

  useEffect(() => {
    getSingleTemplates()
  }, [templateId]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className='mt-4'>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={userSchema}
          enableReinitialize={true}
          validateOnChange
          validateOnMount
        >
          {(formik) => {
            console.log(formik.values, 'formikvalues');
            
            
            setTemplateId(formik?.values?.reportTemplate?.id)
            return (
              <Form>
                {scheduleDataLoading ? (
                  <Skeleton
                    height={800}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : (
                  <Modal
                    show={isActive}
                    onHide={() => {
                      formik.resetForm()
                      setIsActive(false)
                      setScheduleReportData(null)
                      setScheduleId(null)
                    }}
                    size='lg'
                    fullscreen
                  >
                    <Modal.Header closeButton>
                      <h2>
                        {scheduleData
                          ? formatMessage({ id: 'Edit Schedule Report' })
                          : formatMessage({ id: 'Schedule Reports' })}
                      </h2>
                    </Modal.Header>
                    <Modal.Body>
                      <div className='container'>
                        <div className='mt-4'>
                          <InfoCard2
                            title={'Scheduling Reports for Automated Delivery'}
                            desc={
                              'This page allows you to schedule reports on user activities, file access, modifications, and more. Define the specific actions, users, departments, and file categories to include in the report. Set a report frequency and choose recipients for automated delivery. Use this feature to ensure timely reports for auditing and monitoring purposes.'
                            }
                            slug={''}
                          />
                        </div>

                        <div className='rounded-2 mt-6'>
                          <h2 className='font-size-16'>{formatMessage({ id: 'Schedule Report' })}</h2>

                          <>
                            <Row>
                              <Col md={6}>
                                <SelectSearchInput
                                  label={formatMessage({ id: 'Report Templete' })}
                                  fieldName='reportTemplate'
                                  placeholder={formatMessage({ id: 'Select Report Templete' })}
                                  formik={formik}
                                  toolTipText={formatMessage({
                                    id: 'Choose an existing predefined report template to automatically populate report details for generation.',
                                  })}
                                  options={templateOptions}
                                  isStarRequired
                                />

                                <p className='text-primary m-0'>
                                  {formatMessage({
                                    id: 'Choose an existing predefined report template to automatically populate report details for generation.',
                                  })}
                                </p>
                              </Col>

                              <Col md={6}>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Schedule Name' })}
                                  fieldName='scheduleName'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Schedule Name' })}
                                  toolTipText={formatMessage({
                                    id: 'Enter a unique name for this schedule to easily identify it later.',
                                  })}
                                  isStarRequired={true}
                                  isTooltipForModal={true}
                                />
                              </Col>
                            </Row>
                            <div
                              style={{ background: 'rgb(71 118 230 / 4%)' }}
                              className='p-4 rounded-2 mt-4'
                            >
                              <h2 className='font-size-16 m-0'>
                                {formatMessage({
                                  id: 'Report Information & Details in selected Template',
                                })}
                              </h2>

                              <Row className='mt-4'>
                                <Col md={8}>
                                  <TextInput
                                    fieldType='text'
                                    label={formatMessage({
                                      id: 'I want to generate the report of below activity type (e.g., file access, upload, modification)',
                                    })}
                                    fieldName='AccessActivity'
                                    formik={formik}
                                    placeholder={formatMessage({ id: 'Access Activities' })}
                                    toolTipText={formatMessage({
                                      id: 'Select the type of activities to include in the report, such as file access, upload, or modification.',
                                    })}
                                    isStarRequired={true}
                                    isTooltipForModal={true}
                                    isDisabled={true}
                                  />
                                </Col>
                              </Row>

                              <Row>
                                <Col md={12}>
                                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                                    {formatMessage({ id: 'For below actions' })}{' '}
                                    <ToolTipUIForModal
                                      tooltipText={formatMessage({
                                        id: 'Choose the specific actions you want to report on, such as record access or permission changes.',
                                      })}
                                    />
                                  </label>

                                  <div className='d-flex w-100  align-items-center'>
                                    <div className='d-flex align-items-center gap-2'>
                                      <TextInput
                                        fieldName={'recordAccess'}
                                        formik={formik}
                                        customText={formatMessage({ id: 'Record Access' })}
                                        placeholder=''
                                        fieldType={'checkbox'}
                                        isCheckbox={true}
                                        isWidthNotRequired={true}
                                        isTooltipNotRequired={true}
                                        isDisabled={true}
                                        checkboxSize='24'
                                      />
                                    </div>

                                    <div className='d-flex align-items-center gap-2'>
                                      <TextInput
                                        fieldName={'permissionChanges'}
                                        formik={formik}
                                        customText={formatMessage({ id: 'Permission Changes' })}
                                        placeholder=''
                                        fieldType={'checkbox'}
                                        value={scheduleReportData?.permissionChanges}
                                        isCheckbox={true}
                                        isWidthNotRequired={true}
                                        isTooltipNotRequired={true}
                                        isDisabled={true}
                                        checkboxSize='24'
                                      />
                                    </div>

                                    <div className='d-flex align-items-center gap-2'>
                                      <TextInput
                                        fieldName={'unauthorized'}
                                        formik={formik}
                                        customText={formatMessage({
                                          id: 'Unauthorized Access Attempts',
                                        })}
                                        placeholder=''
                                        fieldType={'checkbox'}
                                        isCheckbox={true}
                                        isWidthNotRequired={true}
                                        isTooltipNotRequired={true}
                                        isDisabled={true}
                                        checkboxSize='24'
                                      />
                                    </div>

                                    <div className='d-flex align-items-center gap-2'>
                                      <TextInput
                                        fieldName={'linkSharing'}
                                        formik={formik}
                                        customText={formatMessage({ id: 'Link Sharing' })}
                                        placeholder=''
                                        fieldType={'checkbox'}
                                        isCheckbox={true}
                                        isWidthNotRequired={true}
                                        isTooltipNotRequired={true}
                                        isDisabled={true}
                                        checkboxSize='24'
                                      />
                                    </div>

                                    <div className='d-flex align-items-center gap-2'>
                                      <TextInput
                                        fieldName={'geoLocation'}
                                        formik={formik}
                                        customText={formatMessage({ id: 'Geolocation of Access' })}
                                        placeholder=''
                                        fieldType={'checkbox'}
                                        isCheckbox={true}
                                        isWidthNotRequired={true}
                                        isTooltipNotRequired={true}
                                        isDisabled={true}
                                        checkboxSize='24'
                                      />
                                    </div>
                                  </div>
                                </Col>
                              </Row>

                              <Row className='mt-4'>
                                <Col md={8}>
                                  <TagifyInput
                                    label={formatMessage({ id: 'Of below Users' })}
                                    placeholder={formatMessage({ id: 'Add User' })}
                                    tooltip={formatMessage({
                                      id: 'Select users whose activities should be included in this report.',
                                    })}
                                    fieldName='validUsers'
                                    formik={formik}
                                    isDisabled={true}
                                  />
                                </Col>
                              </Row>

                              <Row className='mt-4'>
                                <Col md={6}>
                                  <TagInput
                                    label={formatMessage({ id: 'From these departments' })}
                                    initialOptions={[]}
                                    placeholder={formatMessage({ id: 'Add Department' })}
                                    tooltip={formatMessage({
                                      id: 'Select departments to filter activities and records belonging to those specific departments.',
                                    })}
                                    fieldName='departmentLists'
                                    formik={formik}
                                    disabled={true}
                                  />
                                </Col>

                                <Col md={6}>
                                  <TagInput
                                    label={formatMessage({ id: 'From these categories' })}
                                    initialOptions={[]}
                                    placeholder={formatMessage({ id: 'Add Category' })}
                                    tooltip={formatMessage({
                                      id: 'Filter records by categories to include specific document groups in the report.',
                                    })}
                                    fieldName='categoryLists'
                                    formik={formik}
                                    disabled={true}
                                  />
                                </Col>
                              </Row>

                              <div className='d-md-flex flex-md-column mt-4'>
                                <div className='d-flex form-label  text-dark font-size-13'>
                                  {formatMessage({ id: 'In this output format' })}{' '}
                                  <ToolTipUIForModal
                                    tooltipText={formatMessage({
                                      id: 'Choose the file format for exporting the report, either PDF or XLS.',
                                    })}
                                  />
                                </div>
                                <div className='d-flex align-items-center gap-4'>
                                  {/* <div className='d-flex align-items-center gap-1'>
                                  <input
                                    type='radio'
                                    id='employee-yes'
                                    name='format'
                                    value='PDF'
                                    onChange={formik.handleChange}
                                    checked={formik?.values?.format === 'PDF'}
                                    width={48}
                                    height={48}
                                    disabled={true}
                                  />
                                  <label htmlFor='employee-yes'>{formatMessage({ id: 'PDF' })}</label>
                                </div> */}
                                  <div className='d-flex align-items-center gap-1'>
                                    <input
                                      type='radio'
                                      id='employee-no'
                                      name='format'
                                      onChange={formik.handleChange}
                                      checked={true}
                                      value='XLS'
                                      width={48}
                                      height={48}
                                      disabled={true}
                                    />
                                    <label htmlFor='xlsx'>{formatMessage({ id: 'XLSX' })}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <h2 className='font-size-16 mt-6 mb-4'>
                              {formatMessage({ id: 'Schedule & Share' })}
                            </h2>
                            <Row>
                              <Col md={6}>
                                <SelectInput
                                  label={formatMessage({ id: 'Report Frequency' })}
                                  fieldName='reportFrequency'
                                  placeholder={formatMessage({
                                    id: 'Select Stakeholder Category',
                                  })}
                                  formik={formik}
                                  toolTipText={formatMessage({
                                    id: 'Please select how frequently this report will be generated & sent to under this schedule.',
                                  })}
                                  options={['Daily', 'Weekly', 'Monthly', 'Yearly']}
                                  isStarRequired={false}
                                  isTooltipForModal={true}
                                />
                              </Col>

                              <Col md={6}>
                                <Row className='mt-0'>
                                  <Col md={8}>
                                    {emailListLoading ? (
                                      <>
                                        <div className='w-100'>
                                          <Skeleton
                                            height={20}
                                            width={250}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <TagInput
                                        label={formatMessage({ id: 'Email Report to' })}
                                        initialOptions={emailList}
                                        placeholder={formatMessage({ id: 'Enter Email IDs' })}
                                        tooltip={formatMessage({
                                          id: 'The email address(es), separated by comma, where the generated report will be sent to as per schedule.',
                                        })}
                                        fieldName='reportEmail'
                                        formik={formik}
                                        isEmails={true}
                                      />
                                    )}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer className='container px-0'>
                      <div className='d-md-flex w-100 justify-content-end px-md-0 px-0 gap-3'>
                        <button
                          type='button'
                          className='btn bg-light custom-button-property text-muted w-auto'
                          onClick={() => {
                            formik.resetForm()
                            setIsActive(false)
                            setScheduleReportData(null)
                          }}
                        >
                          {formatMessage({ id: 'Cancel' })}
                        </button>

                        <button
                          type='submit'
                          className='btn bg-primary custom-button-property text-white w-auto'
                          disabled={!formik.isValid || isLoading}
                          onClick={formik.submitForm}
                        >
                          {!isLoading ? (
                            <span className='indicator-label font-size-13 p-0'>
                              {scheduleData
                                ? formatMessage({ id: 'Edit schedule Report' })
                                : formatMessage({ id: 'Schedule Report' })}
                            </span>
                          ) : (
                            <span className='indicator-label font-size-13 p-0'>
                              {formatMessage({ id: 'Please wait...' })}
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          )}
                        </button>
                      </div>
                    </Modal.Footer>
                  </Modal>
                )}
              </Form>
            )
          }}
        </Formik>
      </div>
    </>
  )
}

export default ScheduleReportModal
